import { Component, Input, OnInit } from '@angular/core';
import { ComponentRendering, Item } from '@sitecore-jss/sitecore-jss/layout';
import { GetItemListFieldsService } from '../../../shared/services/get-item-list-fields.service';
import { CreditCardsService, ICard } from '../../services/credit-cards.service';

@Component({
  selector: 'ab-credit-cards-limit-overview',
  templateUrl: './credit-cards-limit-overview.component.html',
  styleUrls: ['./credit-cards-limit-overview.component.scss']
})
export class CreditCardsLimitOverviewComponent implements OnInit {
  @Input() rendering: ComponentRendering;

  public tableColumns: Item[];
  public isLoading = true;
  public items: { [key: string]: Item };
  public cards: Array<ICard>;

  constructor(
    private getItemListFieldsService: GetItemListFieldsService,
    private creditCardsService: CreditCardsService
  ) {}

  ngOnInit(): void {
    this.tableColumns = (this.rendering.fields.items as Item[]).filter(
      i => i.name !== 'Metadata'
    ) as Item[];

    this.items = this.getItemListFieldsService.getItems(
      (this.rendering.fields.items as Item[]).filter(
        i => i.name === 'Metadata'
      )[0].fields.items as Item[]
    );

    this.creditCardsService.getCreditCards().subscribe(
      response => {
        this.isLoading = false;
        this.cards = response.cards;
      },
      () => (this.isLoading = false)
    );
  }

  setOdd(i: number) {
    return i % 2 === 0;
  }
}
